<div class="modal__header">
	<h2 class="title" id="modal__title">Recover Client number</h2>
	<div class="modal__header-actions">
		<button aria-label="Close dialog" (click)="closeModal()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'Close icon'"></app-svg>
		</button>
	</div>
</div>
<div class="modal__body">
	<div class="bold">Forgotten your TAP Miles&Go client number?</div>
	<div class="content">
		<div class="row">
			Please contact us and we will help you: </div>
		<div class="row">
			<ul>
				<li class="row">
					<app-svg class="icon" svg="icons.svg#digital_universe--mobile_phone" aria-hidden="true" [alt]="'phone number'">
					</app-svg>
					<a class="link" href="tel:+443456010932">+44 (0) 345 601 0932</a>
				</li>
				<li class="row">
					<app-svg class="icon" svg="icons.svg#informative--time_and_schedule" aria-hidden="true" [alt]="'schedule'">
					</app-svg>Daily: 24h
				</li>
			</ul>
		</div>
	</div>
</div>
